export default __webpack_public_path__ + "media/joe.463c48b7.jpg";